import { gql } from "gql";

export const REMOVE_BPM_ROLE_ASSIGNMENT = gql(`
  mutation RemoveBpmRoleAssignment ($id: ID!) {
    removeHrRoleAssignment(id: $id)
  }
`);
